export const fmtCurrency = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "$0";
  const { compact = false, decimals = 0 } = opts;
  if (compact && Math.abs(n) >= 1000) {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(n);
  }
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);
};

export const fmtNumber = (n) =>
  new Intl.NumberFormat("en-CA").format(Math.round(n || 0));

export const fmtPct = (n, decimals = 2) => `${(n * 100).toFixed(decimals)}%`;

export const parseNum = (v) => {
  if (v === "" || v === null || v === undefined) return 0;
  const cleaned = String(v).replace(/[^0-9.\-]/g, "");
  const n = parseFloat(cleaned);
  return isNaN(n) ? 0 : n;
};

export const DEFAULT_INPUTS = {
  annual_contribution: 200000,
  passive_return_rate: 0.05,
  passive_tax_rate: 0.5017,
  num_vehicles: 15,
  avg_monthly_payment: 950,
  avg_loan_interest_rate: 0.079,
  avg_loan_term_years: 5,
  num_key_employees: 4,
  annual_retention_bonus: 15000,
  turnover_cost_per_employee: 60000,
  retention_probability_boost: 0.5,
  dividend_rate: 0.0635,
  horizon_years: 10,
};
